import React from 'react';

const SuggestionTooltip = ({ i18n }) => {
  return (
    <div className="synonym-direction-tooltip">
      <p>
        {i18n.translate('AdminHTML.Synonym.Tooltip.suggestion_check', {
          t1: <strong>{i18n.translate('AdminHTML.Synonym.Tooltip.suggestion_check_t1')}</strong>
        })}
      </p>
      <p style={{ paddingTop: '0.25rem' }}>
        {i18n.translate('AdminHTML.Synonym.Tooltip.suggestion_uncheck', {
          t1: <strong>{i18n.translate('AdminHTML.Synonym.Tooltip.suggestion_uncheck_t1')}</strong>
        })}
      </p>
    </div>
  );
};

export default SuggestionTooltip;
